import { MetaData, RenderChartOutput } from '@react/data-hub/types/misc';
import { SearchInsights } from '@sly/core/src/types';
import { createContext } from 'react';

const DatahubContext = createContext<{
  searchInsights: SearchInsights | null;
  locationString: string;
  locationStringWithCountryCode: string;
  metadata: MetaData | null;
  chartSvgs?: RenderChartOutput;
}>({
  searchInsights: null,
  locationString: '',
  locationStringWithCountryCode: '',
  metadata: null,
  chartSvgs: {
    yoyLineChart: '',
    yoyBarChart: '',
    allegationsBarChart: '',
    citationBarChart: '',
    inspectionsBarChart: '',
  },
});

export default DatahubContext;
